import FormattedMessage from 'I18n/components/FormattedMessage';
import { USER_DEFINED } from 'customer-data-filters-ui/filterQueryFormat/associations/AssociationCategory';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorRelatedConditionsHeadingAssociationSelectValueComponent = props => {
  const {
    option
  } = props;
  if (option.value.endsWith(USER_DEFINED)) {
    if (option.inverseText) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterFamilyGroupHeadingAssociation.labeledEditorSelectWithInverseLabel",
        options: {
          associationLabel: option.text,
          inverseAssociationLabel: option.inverseText,
          entityName: option.associatedObjectName
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterFamilyGroupHeadingAssociation.labeledEditorSelect",
      options: {
        associationLabel: option.text,
        entityName: option.associatedObjectName
      }
    });
  }
  return option.text;
};
export default EditorRelatedConditionsHeadingAssociationSelectValueComponent;